import React, { useEffect, useRef } from "react";
import $ from "jquery";
import "datatables.net-dt/js/dataTables.dataTables.js";
import "datatables.net-responsive-dt/js/responsive.dataTables.js";
import "datatables.net-responsive-dt/css/responsive.dataTables.css";
import { API_URL } from "..";

const UomListLayer = ({ data = [], onAdd, onEdit, onRefresh }) => {
  const tableRef = useRef(null);

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this UOM?")) return;

    const res = await fetch(`${API_URL}/api/uom/${id}`, { method: "DELETE" });

    if (res.ok) onRefresh();
    else alert("Failed to delete");
  };

  useEffect(() => {
    if ($.fn.DataTable.isDataTable("#uomTable")) {
      $("#uomTable").DataTable().destroy(true);
    }

    tableRef.current = $("#uomTable").DataTable({
      data,
      responsive: true,
      pageLength: 10,
      columns: [
        { data: "id", title: "ID" },
        { data: "title", title: "Unit of Measure" },
        {
          data: null,
          title: "Actions",
          orderable: false,
          render: (row) => `
            <div class="d-flex align-items-center gap-2" style="display: flex !important; flex-direction: row !important; align-items: center; gap: 8px;">
              <button class="btn btn-sm btn-primary edit-btn" data-id="${row.id}" data-title="${row.title}">
                Edit
              </button>
              <button class="btn btn-sm btn-danger delete-btn" data-id="${row.id}">
                Delete
              </button>
            </div>
          `,
        },
      ],
    });

    $("#uomTable tbody").on("click", ".edit-btn", function () {
      onEdit({ id: $(this).data("id"), title: $(this).data("title") });
    });

    $("#uomTable tbody").on("click", ".delete-btn", function () {
      handleDelete($(this).data("id"));
    });

    return () => {
      if ($.fn.DataTable.isDataTable("#uomTable")) {
        $("#uomTable").DataTable().destroy(true);
      }
    };
  }, [data]);

  return (
    <div className="card basic-data-table">
      <div className="card-header">
        <div className="row">
          <h5 className="col-md-6 card-title mb-0">Units of Measure</h5>
          <div className="col-md-6 text-end">
            <button className="btn btn-info" onClick={onAdd}>Add New UOM</button>
          </div>
        </div>
      </div>
      <div className="card-body">
        <table className="table bordered-table mb-0" id="uomTable"></table>
      </div>
    </div>
  );
};

export default UomListLayer;
